import React, { useState } from 'react';
import { useFetchMatch } from '../data/fetchMatch';
import { getLabel } from '../InitData';
import { filterSearchResults, getBetDescription } from '../data/utils';
import FastBetsOdd from './FastBetsOdd';
import Loader from './Loader';
import { getAllAgg } from '../data/data';

function FastbetDropdownContent(props) {
    //const match = props.match;
    /* Incorporo il match in uno stato, puo' essere modificato solo con chiamata a setMatch */
    const [match,setMatch] = useState(props.match);
    const agTutte = getAllAgg(match.isLive, match.sportRef).idAggregata;
    const [state, ,isSetInterval] = useFetchMatch(match, agTutte, match.isLive, false); /* useState su props.match mi permette di evitare che questa chiamata parta 
                                                                               ad ogni rendering dei componenti padre */
    const [search, setSearch] = useState(null);

    function handleChange(event) {
        setSearch(event.target.value);
    }

    if (!match.isLive&&(state.isLoading || state.isError)) {
        return <Loader error={state.isError} />;
    }else{
        if(!state.data&&state.isLoading&&!isSetInterval){
            return <Loader error={state.isError} />;
        }
           
    }
    //Se "Live" e timestamp cambiato, chiamo setMatch per rieseguire il rendering e chiamare useFetchMatch per ottenere le quote aggiornate
    if(props.match.isLive&&props.match.timestamp!==match.timestamp){
        setMatch(props.match);
    }

    let bets = state.data.bets.filter(bet => bet.hasOdds === true);
    if (search != null) {
        bets = filterSearchResults(bets, search, 'BET', function(bet) {
            return bet.desc;
        });
    }

    return (
        <>
            <div className="ricerca-fastbet-in-quote">
                <input className="input-personalizzato-fastbet-ricerca" type="text" id="ric-fastbet-in-quota" placeholder={getLabel('general.ricerca')} onChange={handleChange} autoFocus autoComplete="off" />
            </div>
            <ul className="lista-quote-interna-fastbet">
                <>
                    {bets.map(function(bet, i) {
                        return (
                            <li key={i}><span className="grassetto">{getBetDescription(bet, false)}</span>
                                <ul className="ml-4">
                                    <>
                                        {bet.odds.filter(odd => odd.value).map(function(odd, i) {
                                            return (
                                               <FastBetsOdd  key={i} {...odd} matchData={match} betsData={bet} />
                                            )
                                        })}
                                    </>
                                </ul>
                            </li>
                        )
                    })}
                </>
            </ul>
        </>
    );
}

export default FastbetDropdownContent;
